import queries from '../../css/media-queries.json';
import _reduce from 'lodash/collection/reduce';

export default () => {
	return _reduce(queries, (acc, value, key) => {
		if(value.min || value.max) {
			if(value.min) acc[key + '-min'] = value.min;
			if(value.max) acc[key + '-max'] = value.max;
		}
		else {
			acc[key] = value;
		}

		return acc;
	}, {});
};



// WEBPACK FOOTER //
// ./src/js/tools/getQuery.js